import { Link } from 'react-router-dom';
import { useAuth } from '@/components/AuthProvider';
import { homePathForRole } from '@/lib/supabase';

export default function NotFound() {
  const { role } = useAuth();
  const home = role ? homePathForRole(role) : '/';

  return (
    <div
      style={{
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        padding: 24,
        textAlign: 'center',
      }}
    >
      <img src="/assets/illustrations/search.png" alt="" width={96} height={96} />
      <p style={{ fontSize: 56, fontWeight: 800, color: 'var(--ink)', lineHeight: 1 }}>404</p>
      <h1 style={{ fontSize: 22, fontWeight: 800, color: 'var(--ink)' }}>Page introuvable</h1>
      <p style={{ color: 'var(--text-muted)', maxWidth: '40ch' }}>
        La page que vous cherchez n&apos;existe pas ou a été déplacée.
      </p>
      <Link className="btn btn--primary" to={home}>
        Retour à l&apos;accueil
      </Link>
    </div>
  );
}
